export const ALL_LOCALES = ['de', 'en', 'es', 'fr', 'it'] as const;
export const VISIBLE_LOCALES = ['de', 'en'] as const;
export const DEPRECATED_LOCALES = ['es', 'fr', 'it'] as const;

export type Locale = (typeof ALL_LOCALES)[number];
